module.exports = __webpack_public_path__ + "8145d6345072193b5fb5ac726d20e78d.fbx";